import { Component, inject } from '@angular/core';
import { ApiUsuarioService } from 'src/app/services/api-usuario.service';
import { AppService } from 'src/app/services/app.service';
import { TrialService } from 'src/app/services/trial.service';

@Component({
  templateUrl: 'trial-expirado.component.html',
  selector: 'menu-item-saude-trial-expirado'
})
export class MenuItemSaudeTrialExpiradoComponent {
  private readonly apiUsuario = inject(ApiUsuarioService);
  private readonly appService = inject(AppService);
  protected readonly trialService = inject(TrialService);
  protected readonly isAdministrativo = this.apiUsuario.isUserAdmin();
  protected readonly isFilial = this.appService.isFilial();
  protected readonly referenciaMatriz = this.appService.referenciaAdministracaoMatriz();
}
